document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function() {
    const labels = document.querySelectorAll('.custum_label div label');

    labels.forEach(function(label) {
      const fullText = label.innerText;
      const parts = fullText.split('(');

      if (parts.length > 1) {
        const mainText = parts[0].trim();
        const spanText = '(' + parts.slice(1).join('('); // Gère les cas avec plusieurs parenthèses
        label.innerHTML = `${mainText} <span class="text-small">${spanText}</span>`;
        label.setAttribute("aria-label", fullText.trim());
      }
    });
  }, 500);
});
